import { render } from "./editClient.vue?vue&type=template&id=14ad1419&scoped=true"
import script from "./editClient.vue?vue&type=script&lang=js"
export * from "./editClient.vue?vue&type=script&lang=js"

import "./editClient.vue?vue&type=style&index=0&id=14ad1419&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/cleanshift_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ad1419"]])

export default __exports__